import {
  Button,
  Card,
  CardHeader,
  Grid,
  Snackbar,
  TextField,
} from "@material-ui/core";
import { Field, Form, Formik } from "formik";
import React, { useState } from "react";
import * as Yup from "yup";
import useApi from "../../../../../hooks/api";
import Alert from "../../../../ui/alert";
import "./update_password.css.scss";

const UpdatePassword = (props) => {
  const { patch } = useApi();

  const [pwdUpdated, setPwdUpdated] = useState(false);

  const SignupSchema = Yup.object().shape({
    password: Yup.string().required("A nova senha não pode ficar em branco!"),
    password_confirmation: Yup.string().oneOf(
      [Yup.ref("password"), null],
      "As senhas devem ser iguais!"
    ),
  });

  const CustomField = ({ field, form, ...props }) => {
    const error = form.errors[field.name];

    return (
      <TextField
        {...props}
        {...field}
        error={error != undefined}
        helperText={error}
        style={{
          width: "47.5%",
          marginRight: field.name == "password" ? "2.5%" : null,
        }}
      />
    );
  };

  const initialValues = {
    password: "",
    password_confirmation: "",
  };

  const handleSubmit = (values, actions) => {
    patch("/auth/password", values)
      .then(() => {
        setPwdUpdated(true);
        actions.resetForm(initialValues);
        actions.setSubmitting(false);
      })
      .catch(() => {
        alert(
          "Não conseguimos alterar sua senha. Por favor, tente mais tarde!"
        );
        actions.setSubmitting(false);
      });
  };

  return (
    <Grid item xs={12} md={6}>
      <Card elevation={4}>
        <CardHeader
          disableTypography
          title="Minha senha"
          style={{ fontSize: "16px", fontWeight: "bold" }}
        />

        <div className="panel-body">
          <Formik
            initialValues={initialValues}
            validationSchema={SignupSchema}
            onSubmit={handleSubmit}
          >
            {({ errors, touched, ...formikProps }) => (
              <Form>
                <div className="row">
                  <Field
                    name="password"
                    type="password"
                    label="Nova senha"
                    component={CustomField}
                  />

                  <Field
                    name="password_confirmation"
                    type="password"
                    label="Confirme a nova senha"
                    component={CustomField}
                  />
                </div>

                <div className="row">
                  <div className="form-group col-md-6 m-t-20">
                    <Button
                      disabled={
                        !(formikProps.isValid && formikProps.dirty) ||
                        formikProps.isSubmitting ||
                        formikProps.values.password_confirmation == ""
                      }
                      fullWidth
                      className="btn btn-primary btn-mercatorio"
                      type="submit"
                    >
                      Atualizar
                    </Button>
                  </div>
                </div>
              </Form>
            )}
          </Formik>

          <Snackbar
            open={pwdUpdated}
            autoHideDuration={5000}
            anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
            onClose={() => setPwdUpdated(false)}
          >
            <Alert message="Senha alterada com sucesso!" />
          </Snackbar>
        </div>
      </Card>
    </Grid>
  );
};

export default UpdatePassword;
